import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, Params, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { AddressesService } from "../services/addresses.service"
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-create-address',
  templateUrl: './create-address.component.html',
  styleUrls: ['./create-address.component.css']
})
export class CreateAddressComponent implements OnInit {
  client;
  clientid;
  user;
  referer;
  isLoggedIn$: Observable<boolean>
  shipperValid = false;
  newShipper;
  shipperid = 1; // set when new shipper id returned from DB (index for now)

  constructor(private router: Router,
              private route: ActivatedRoute,
              private addressesService: AddressesService,
              private location: Location,
              private authService: AuthService ) {  }

  ngOnInit() {
        // Create newShipper object to use in html
    this.newShipper = {
      name: "", address: "", city: "", state: "", zip: "", fname: "", lname: "", phone: ""
    }
    this.route.params
    .subscribe(
      (params: Params) => {
        this.clientid = + params['clientid'];
      }
    );
    this.onStartup();

  }

  onStartup() {
    this.isLoggedIn$ = this.authService.isLoggedIn$
    this.authService.user$.subscribe((user:any) => {
      console.log(user)
      this.user = user;
      if(!user.message) {
        if( user.clientid == 0) {
          this.authService.client$.subscribe((client) => {
            console.log(client)
            this.client = client;
          });
        }else { 
          this.authService.client$.subscribe((client) => {
            console.log(client)
            this.client = client;
            if(client.cname != 'No Client Selected' && user.clientid != 0){
              
              }
            })
        }
      }        
    })
  }

    onCancelClose(bool) {
      this.location.back();
  }

    onValidateForm() {    
    if(this.newShipper.name != "" &&
        this.newShipper.address !=""&&
        this.newShipper.city !="" &&
        this.newShipper.state !="" &&
        this.newShipper.zip !="" &&
        this.newShipper.fname !="" &&
        this.newShipper.lname !="" &&
        this.newShipper.phone !="" 
    ) {      
      this.shipperValid = true;
    }
  }

  onSaveNewAddress(){
    this.addressesService.onAddAddress(this.newShipper, this.clientid)
    .then(newAddress => {
      let inserted = newAddress;
      
      this.location.back();
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/create-address/create-address.component.ts